import { useContext } from "react";
import { MyContext } from "../App";
import { useInView } from "react-intersection-observer";
import { motion } from "framer-motion";

const Footer = () => {
  const { Lang } = useContext(MyContext);
  const { ref, inView } = useInView({ triggerOnce: true, threshold: 0.1 });

  return (
    <footer ref={ref} className="py-6 text-center overflow-hidden bg-black">
      <motion.p initial={{ opacity: 0 }}
        animate={inView ? { opacity: 1 } : { opacity: 0 }}
        transition={{ delay: 1 }} className="text-white/70 ">
        &copy; {new Date().getFullYear()}{" "}
        {Lang === 'Ar' ? 'حكيم حيزمي. جميع الحقوق محفوظة' : (Lang === 'Fr' ? 'Hakim Hizmi. Tous droits réservés' : 'Hakim Hizmi. All  rights reserved')}
      </motion.p>
    </footer>
  );
};

export default Footer;
